




















































import { PropType, defineComponent, getCurrentInstance } from '@vue/composition-api';
import { Message, RecommendData, RecommendItem } from '../../dataType';
import Card from './Card.vue';
import { useLocale } from '../../hooks/useLocale';
import { useRecommendMessage, useMessage } from '../../hooks/useMessage';
import { useMessageInteract } from '../../hooks/useMessageInteract';
export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<RecommendData>>,
      required: true
    }
  },
  setup(props) {
    const { t } = useLocale();
    const instance = getCurrentInstance()?.proxy!;

    const { addUserTextMessage, robotWaitWithAsyncOperation, sendMessageAndUpdateId } = useMessage();
    const { recommends, isSingleRecommend, singleTitle } = useRecommendMessage(props.message);
    const { isDisabled } = useMessageInteract(props.message);
    const confirm = (event: Event, params: any, sendText?: string, filter?: boolean) => {
      const actionParams = {
        id: props.message.content.base.id || 0,
        inputText: {
          text: sendText || '',
          push: true,
          save: true
        },
        actionType: filter ? 'query_data_filter' : 'query_data',
        actionJson: params
      };
      let msg: Message<any> | null = null;
      if (sendText) {
        msg = addUserTextMessage(sendText);
      }
      robotWaitWithAsyncOperation(() => sendMessageAndUpdateId(msg, 'confirm', actionParams, {
        parabolaAnimation: true,
        intent: props.message.content.intent,
        event
      }));
    };
    const ok = (recommend: RecommendItem, event: Event) => {
      confirm(event, {
        chatId: props.message.content.base.chatId,
        intentCode: props.message.content.intent,
        params: {
          ...props.message.content.params,
          ...recommend.item.params
        },
        // eslint-disable-next-line spellcheck/spell-checker
        gptResponse: props.message.content.gptResponse,
        placeholderContent: props.message.content.base.placeholderContent,
        source: props.message.content.base.source,
        taskId: props.message.content.base.taskId
      }, recommend.label);
      instance.$track.send('WebIM_SendIntent', {
        Send_Type: '反问推荐',
        Intent_Type: props.message.content.intent
      }, true);
    };
    const yes = (event: Event) => {
      confirm(event, {
        chatId: props.message.content.base.chatId,
        intentCode: props.message.content.intent,
        params: {
          ...props.message.content.params,
          ...(props.message.content.recommend?.[0]?.params || {})
        },
        // eslint-disable-next-line spellcheck/spell-checker
        gptResponse: props.message.content.gptResponse,
        placeholderContent: props.message.content.base.placeholderContent,
        source: props.message.content.base.source,
        taskId: props.message.content.base.taskId
      }, props.message.content.recommend?.[0]?.content || t('button.yes'));
      instance.$track.send('WebIM_ConfirmInfo', { Button_TypeAndIntent: ['是的', props.message.content.intent] }, true);
    };

    return {
      t,
      recommends,
      isSingleRecommend,
      singleTitle,
      isDisabled,
      ok,
      yes,
      filter(event: Event) {
        confirm(event, {
          reshowHeader:t('saas.robotChat.card.filterTitle')
        }, t('saas.robotChat.buttonFilter'), true);
        instance.$track.send('WebIM_ConfirmInfo', { Button_TypeAndIntent: ['不对去筛选', props.message.content.intent] }, true);
      }
    };
  }
});
